import { render, staticRenderFns } from "./SancionesCard.vue?vue&type=template&id=7b13fff8"
import script from "./SancionesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SancionesCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports